import classNames from 'classnames';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';
import { ILeadNoteSearched, EDashboardView } from 'common/interfaces/provider';
import moment = require('moment');
import { computed } from 'mobx';

// Styles
const s = require('./SalesDashboardLeadOrNoteCard.css');

// Props
interface ISalesDashboardNoteProps extends IAppOnlyStore {
  index: number;
  note: ILeadNoteSearched;
}

// Component
@inject('store')
@observer
export class SalesDashboardNote extends React.Component<
  ISalesDashboardNoteProps,
  {}
> {
  @computed private get isEvenEntry(): boolean {
    return this.props.index % 2 <= 0;
  }

  @computed
  private get noteCommentFormatted(): string {
    const {
      note: { comment },
      store: {
        leads: { notesSearchQuery },
      },
    } = this.props;
    const search = notesSearchQuery.trim();

    if (!comment || comment.trim().length <= 0) {
      return '';
    }

    if (search.length <= 0) {
      return comment;
    }

    const regex = new RegExp(search, 'gi');
    return comment.trim().replace(regex, '<em>$&</em>');
  }

  public render() {
    const {
      note,
      store: {
        leads: { leadsDashboardView },
      },
    } = this.props;

    return (
      <div
        id={this.props.store.lead.generateDashboardNoteCardId(note.id)}
        onClick={this.handleNoteClick}
        className={classNames(s.card, s.note, {
          [s.inList]: leadsDashboardView === EDashboardView.List,
          [s.isEven]: this.isEvenEntry,
        })}
      >
        <div className={s.inner}>
          <div
            id={this.props.store.lead.generateDashboardNoteCardNameId(note.id)}
            className={s.idContainer}
          >
            <p className={s.id}>
              <span>#</span>
              <strong>{note.id}</strong>
            </p>
          </div>

          <a
            className={s.comment}
            dangerouslySetInnerHTML={{
              __html: this.noteCommentFormatted,
            }}
          />

          {(leadsDashboardView === EDashboardView.List &&
            this.renderNoteCustomerName()) ||
            this.renderNoteDate()}

          {(leadsDashboardView === EDashboardView.List &&
            this.renderNoteDate()) ||
            this.renderNoteCustomerName()}
        </div>
      </div>
    );
  }

  private renderNoteDate() {
    const { note } = this.props;

    return (
      <ul className={classNames(s.details, s.lastActivity, s.noteDate)}>
        {typeof note.updatedAt !== 'undefined' && note.updatedAt !== null && (
          <li>
            {'Note written on: '}
            <p>{moment(note.updatedAt).format('MMM, Do - hh:mm A')}</p>
          </li>
        )}
      </ul>
    );
  }

  private renderNoteCustomerName() {
    const { note } = this.props;

    return (
      <ul className={classNames(s.details, s.contact, s.noteContact)}>
        {note.comment && (note.dba || note.legalBusName) && (
          <li>
            {`Lead's DBA and business name: `}
            <p>{note.dba || note.legalBusName}</p>
            {(!note.dba || note.dba !== note.legalBusName) && (
              <p>{note.legalBusName}</p>
            )}
          </li>
        )}
      </ul>
    );
  }

  private handleNoteClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.store.leads.lastNoteId = this.props.note.id;
    this.props.store.lead.handleLeadSelect(this.props.note.providerDatabaseId);
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Dashboard/SalesDashboardNote.tsx